/*
 * Simam Digital — WebXR Showcases hub entry point.
 * Copyright (c) 2026 Simam Digital Ltd.
 */

import './styles/index.css';

import { SHOWCASES } from './showcases';
import { startHero } from './hero';

function iconFor(key) {
	// Minimal inline SVG glyphs so the hub needs no image assets to render.
	const glyphs = {
		sneaker:
			'<path d="M4 30h40a3 3 0 0 0 3-3c0-4-3-6-9-8-5-2-7-3-11-7-2-2-4-2-6-2H10c-2 0-3 1-3 3v17a3 3 0 0 0 3 3z"/><path d="M14 18l5 4M20 16l5 4" stroke-width="2.5" fill="none"/>',
		measure:
			'<rect x="4" y="14" width="44" height="20" rx="3"/><path d="M12 14v6M20 14v9M28 14v6M36 14v9M44 14v6" stroke="#0e0b1a" stroke-width="2.5" fill="none"/>',
		chair:
			'<path d="M14 6v22M38 6v22M12 28h28M16 28l-3 18M36 28l3 18M18 17h16"/>',
		flap: '<path d="M26 8c-8 2-16 8-20 16 8-2 14-1 18 4 2-7 5-13 12-15-3-3-6-4-10-5z"/><circle cx="34" cy="30" r="3"/>',
		flow: '<path d="M4 18c5-6 11-6 16 0s11 6 16 0" stroke-width="3" fill="none"/><path d="M4 30c5-6 11-6 16 0s11 6 16 0" stroke-width="3" fill="none"/>',
		globe: '<circle cx="26" cy="26" r="20" stroke-width="2.5" fill="none"/><ellipse cx="26" cy="26" rx="8" ry="20" stroke-width="2.5" fill="none"/><path d="M7 20h38M7 32h38" stroke-width="2.5" fill="none"/>',
		twin: '<path d="M26 6l18 10v20L26 46 8 36V16z" fill="none" stroke-width="2.5"/><path d="M8 16l18 10 18-10M26 26v20" fill="none" stroke-width="2.5"/>',
		expo: '<rect x="6" y="20" width="12" height="24" fill="none" stroke-width="2.5"/><rect x="20" y="10" width="12" height="34" fill="none" stroke-width="2.5"/><rect x="34" y="24" width="9" height="20" fill="none" stroke-width="2.5"/>',
		earth: '<circle cx="26" cy="26" r="20" fill="none" stroke-width="2.5"/><path d="M10 20c6 3 10-3 16 0s8-2 14 1M8 30c5-2 9 3 14 1s9 2 15-1" fill="none" stroke-width="2.5"/>',
	};
	return `<svg viewBox="0 0 52 52" fill="currentColor" stroke="currentColor" stroke-linejoin="round" stroke-linecap="round">${glyphs[key] || ''}</svg>`;
}

function renderCards() {
	const grid = document.getElementById('card-grid');
	if (!grid) return;

	grid.innerHTML = SHOWCASES.map(
		(s) => `
		<div class="card" style="--card-accent:${s.accent}">
			<a class="card-main" href="${s.href}">
				<div class="card-chip">${iconFor(s.icon)}</div>
				<div class="card-eyebrow">${s.badge}</div>
				<h3 class="card-title">${s.title}</h3>
				<p class="card-desc">${s.description}</p>
				<span class="card-launch">Launch experience <span aria-hidden="true">→</span></span>
			</a>
			<div class="card-foot">
				<span class="card-stat">${s.stat || ''}</span>
				${
					s.caseStudy
						? `<a class="card-cs" href="${s.caseStudy.href}" target="_blank" rel="noopener">${s.caseStudy.label} <span aria-hidden="true">↗</span></a>`
						: ''
				}
			</div>
		</div>`,
	).join('');
}

renderCards();
startHero(document.getElementById('hero-canvas'));
